"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.capReleaseBySharedInvoice = capReleaseBySharedInvoice;
const round_money_js_1 = require("../money/round-money.js");
/**
 * Position release capped by what the invoice still holds after other open requests.
 * FIFO is approval order; this stops a new request from reserving money already asked for.
 */
function capReleaseBySharedInvoice(positionAmount, invoiceLeftover, otherPending = 0) {
    const position = Math.max(0, Number(positionAmount) || 0);
    const leftover = Math.max(0, Number(invoiceLeftover) || 0);
    const pending = Math.max(0, Number(otherPending) || 0);
    const available = Math.max(0, leftover - pending);
    return (0, round_money_js_1.roundMoney)(Math.min(position, available));
}
